export default __webpack_public_path__ + "static/media/bannerCDR 02.c64d9128.png";